import tw, { styled } from "twin.macro";

//Object variants
export const CardsVariant = {
  primary: tw`w-[115.25rem]  bg-white rounded-[3rem] border shadow-lg`,
  secondary: tw`w-[97.375rem]  bg-white rounded-[3rem] border shadow-lg mt-[3.75rem] absolute -right-[60rem]`,
};

export const CardContainer = styled.div(({ theme }) => [
  //variants
  ({ variant }) => CardsVariant[variant],
  //base style
  `font-family: ${theme.fontFamily.secondary};`,
]);

export const CardImage = styled.div(({ variant }) => [
  tw`flex [&>*]:w-full [&>*]:rounded-t-[3rem] [&>*]:object-cover`,
  variant === "secondary" ? tw`[&>*]:h-[33.688rem] ` : tw`[&>*]:h-[40.125rem] `
]);

export const ContentCard = styled.div(({ variant }) => [
  tw`h-fit p-[4.75rem]`,
  variant === "secondary" && tw`min-h-[40.313rem] p-8`,
]);

export const Header = styled.div(tw`w-full flex justify-between`);

export const Title = styled.span(({ theme, titleColor, variant }) => [
  tw`font-medium`,
  variant === "primary"
    ? tw`text-[4.875rem] leading-[4.92rem] mt-[4rem]`
    : tw`text-[4.375rem] leading-[5.381rem]`,
  //Colors
  titleColor ? `color: ${titleColor};` : `color: ${theme.colors.text.primary};`,
]);

export const Status = styled.span(({ open, variant }) => [
  variant === "secondary"
    ? tw`hidden`
    : tw`flex justify-center items-center font-normal text-[4rem] uppercase`,
  //Colors
  open ? tw`text-[#4A995C]` : tw`text-[#E55675]`,
]);

export const Body = styled.div(({ theme, variant }) => [
  tw`font-light py-8`,
  variant === "primary"
    ? tw`text-[4rem] leading-[4.92rem] `
    : tw`text-[3rem] leading-[3.69rem]`,
  `color: ${theme.colors.text.primary};`,
]);

export const Time = styled.div(({ theme, variant }) => [
  variant === "secondary"
    ? tw`hidden`
    : tw`flex font-normal text-[4rem] leading-[4.92rem] text-[#5B5B5B] py-8 gap-[2rem] pb-[6.25rem]`,
]);

export const Line = styled.div(({ theme, variant }) => [
  variant === "primary" && tw`w-full border border-[#7E7E7E]`,
]);

export const LinkSection = styled.div(({ theme, variant }) => [
  variant === "secondary"
    ? tw`hidden`
    : tw`flex justify-center items-center  py-[6.244rem] text-[#0E1222] cursor-pointer`,
]);
export const LinkLabel = styled.span(({ theme }) => [
  tw`font-medium text-[4rem] leading-[4.92rem] uppercase underline ml-[2.379rem]`,
]);
export const BtnSection = styled.div(({ theme }) => [
  tw`flex items-center justify-between`,
]);
export const Direction = styled.span(({ theme, variant }) => [
  variant === "primary"
    ? tw`hidden`
    : tw`flex items-center font-light text-[3.625rem] leading-[4.459rem] uppercase text-[#0E1222] ml-[2.379rem] gap-4`,
]);
